import * as React from 'react';
export const becuSvg = React.forwardRef(function becuSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#AA1F23',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M17.16 6.92c-1.16 0-6.95 2.65-8.88 4.16-1.93 1.51-.77 3.03 0 3.4.77.38 5.79-.37 5.79-.37s-7.34 4.54-8.5 6.8c-1.15 2.28.4 4.55 3.1 4.17 2.7-.38 6.9-3.46 8.63-4.32 1.73-.87 6.42-2.87 6.8-2.87.4 0 .78-.38.78.38s-.39.38-.39 1.14c0 .75.39.75.78.37.38-.37.77-.75 1.15-1.51.4-.76.78-1.9-1.54-1.9-2.32 0-15.44 6.44-16.6 6.82-1.16.38-1.93 0-1.16-1.14.77-1.13 8.1-6.43 8.88-7.19.77-.75.39-2.64-1.16-2.64-1.54 0-3.09.37-3.86.37s-1.16-.75 0-1.13c1.16-.38 6.18-1.51 7.34-2.27 1.15-.76 0-2.27-1.16-2.27z',
      }),
    ),
  );
});
becuSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var becu = {
  category: 'brand',
  colorable: false,
  name: 'becu',
  svg: becuSvg,
};
